import React from 'react';
import styled, { keyframes, css, } from 'styled-components';
import { suppressProps } from '../../utils/index.js';
import { TextIcon } from '../text-icon/index.js';
export const pulse = keyframes `
  0% {
    opacity: 1;
  }

  15% {
    opacity: 0.88;
  }

  30% {
    opacity: 0.72;
  }

  45% {
    opacity: 0.64;
  }

  60% {
    opacity: 0.72;
  }

  75% {
    opacity: 0.88;
  }

  100% {
    opacity: 1;
  }
`;
export const Separator = styled.span(({ theme }) => css `
    margin: ${theme.styles.uiInterspersedText.margin};
  `);
export const StartIcon = styled(TextIcon) ``;
export const EndIcon = styled(TextIcon) ``;
export const ColouredBox = styled.span.withConfig(suppressProps('theme', 'hasContent', 'hasIcon', 'color', 'loadingColor', 'loading', 'fontSize'))(({ theme, color = 'default', loadingColor, loading = true, hasContent, hasIcon, fontSize, }) => {
    const width = {
        x16: theme.sizes.x16,
        x24: theme.sizes.x24,
        x30: theme.sizes.x30,
        x50: theme.sizes.x50,
        fullWidth: '100%',
    }[loading === true ? 'x24' : loading];
    const isEmpty = !hasContent && !hasIcon;
    const skeletonColor = loadingColor
        ? theme.colors.skeletons[loadingColor]
        : theme.colors.textLoading[color];
    return css `
      display: inline-flex;
      align-items: center;
      background-color: ${skeletonColor};
      color: ${theme.colors.transparent};
      user-select: none;
      height: ${fontSize === 'xs' ? theme.sizes.x2 : theme.sizes.x3};
      border-radius: ${theme.radii.x1_5};
      animation: ${pulse} 1.15s ease-in-out infinite;
      width: ${isEmpty ? width : undefined};
      vertical-align: middle;

      ${StartIcon}, ${EndIcon} {
        color: ${theme.colors.transparent};
      }
    `;
});
const getTextWithIconStyles = ({ theme, lineHeight = 'xs', hasContent, }) => css `
  ${StartIcon} {
    margin-right: ${hasContent ? theme.space.x2 : theme.space.x0};
  }

  ${EndIcon} {
    margin-left: ${hasContent ? theme.space.x2 : theme.space.x0};
  }

  ${StartIcon}, ${EndIcon} {
    flex-shrink: 0;
    vertical-align: bottom;
    height: ${theme.lineHeights[lineHeight]};
  }
`;
export const TextElement = styled.span
    .withConfig(suppressProps('loading', 'align', 'color', 'loadingColor', 'fontSize', 'fontWeight', 'letterSpacing', 'lineHeight', 'textDecoration', 'startIcon', 'endIcon', 'hasContent', 'loadingColor'))
    .attrs((props) => ({
    children: props.loading ? (React.createElement(ColouredBox, { hasContent: props.hasContent, hasIcon: Boolean(props.startIcon || props.endIcon), color: props.color, loadingColor: props.loadingColor, loading: props.loading, fontSize: props.fontSize }, props.children)) : (props.children),
}))(({ theme, align, color = 'default', fontSize, fontWeight, letterSpacing, lineHeight = 'xs', textDecoration, loading, }) => css `
    font-size: ${fontSize && theme.fontSizes[fontSize]};
    line-height: ${lineHeight && theme.lineHeights[lineHeight]};
    font-weight: ${fontWeight && theme.fontWeights[fontWeight]};
    letter-spacing: ${letterSpacing && theme.letterSpacings[letterSpacing]};
    text-align: ${align};
    color: ${theme.colors.text[color]};
    text-decoration: ${textDecoration};
    margin: ${theme.space.x0};
    overflow: inherit;
    text-overflow: inherit;
    width: ${loading === 'fullWidth' && '100%'};
  `, getTextWithIconStyles);
//# sourceMappingURL=text.styles.js.map